import { render } from "./NotesSidebar.vue?vue&type=template&id=2495bba5&scoped=true"
import script from "./NotesSidebar.vue?vue&type=script&lang=js"
export * from "./NotesSidebar.vue?vue&type=script&lang=js"

import "./NotesSidebar.vue?vue&type=style&index=0&id=2495bba5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2495bba5"]])

export default __exports__